import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { IonicStorageModule } from '@ionic/storage';
import { MyApp } from './app.component';

import { NearbyPage } from '../pages/nearby/nearby';
import { HomePage } from '../pages/home/home';
import { TabsPage } from '../pages/tabs/tabs';
import { FavoritesPage } from '../pages/favorites/favorites';
import { SearchPage } from '../pages/search/search';
import { ProductPage } from '../pages/product/product';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { Databaseservice } from "../providers/databaseservice";
import { Timeprovider } from "../providers/timeprovider";
import { Favoriteprovider } from '../providers/favoriteprovider';
import { AngularFireModule } from "angularfire2";


export const firebaseConfig = {
    apiKey: "AIzaSyDw1U93-A4DlGYFdpvmrVTCnr5KcyESQYI",
    authDomain: "mijn-geweldige-project-380e5.firebaseapp.com",
    databaseURL: "https://mijn-geweldige-project-380e5.firebaseio.com",
    projectId: "mijn-geweldige-project-380e5",
    storageBucket: "mijn-geweldige-project-380e5.appspot.com",
    messagingSenderId: "467421997957"
};

@NgModule({
  declarations: [
    MyApp,
    NearbyPage,
    HomePage,
    FavoritesPage,
    SearchPage,
    ProductPage,
    TabsPage
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp),
    AngularFireModule.initializeApp(firebaseConfig),
    IonicStorageModule.forRoot()
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    NearbyPage,
    HomePage,
    FavoritesPage,
    SearchPage,
    ProductPage,
    TabsPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    Databaseservice,
    Timeprovider,
    Favoriteprovider,
    IonicStorageModule
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts